import { useMemo, useState } from "react";
import PhotoViewer from "@/components/PhotoViewer";
import { reviewPhotoUrl } from "@/components/reviews/ReviewCard";

export default function useReviewViewer(reviews) {
  const [index, setIndex] = useState(null);
  const photos = useMemo(
    () => reviews.flatMap((r) => (r.photo_paths || []).map((p) => ({ key: p, path: p, src: reviewPhotoUrl(p), alt: `Photo from ${r.name}`, review: r }))),
    [reviews],
  );
  const openPhoto = (path) => {
    const i = photos.findIndex((p) => p.path === path);
    if (i >= 0) setIndex(i);
  };
  const viewer = index !== null && photos[index]
    ? <PhotoViewer photos={photos} index={index} onIndex={setIndex} onClose={() => setIndex(null)} />
    : null;
  return { photos, openPhoto, viewer };
}
